import { useMutation } from '@tanstack/react-query';
import { queryContext } from '@routable/shared';
import { itemApprovalActionsApi } from '../services/actions';
export const useItemApprove = () => useMutation({
    mutationKey: ['itemApprove'],
    mutationFn: itemApprovalActionsApi.approve,
    context: queryContext,
});
